module.exports = __webpack_public_path__ + "img/Superettes.cfc0cd3e.jpg";